<template>
  <form-layout :label="label">
    <select class="form-select" :class="errorMessage ? 'is-invalid' : ''" v-model="value">
      <option />
      <option v-for="option in options" :key="option[valueKey]" :value="option[valueKey]">
        {{ option[textKey] }}
      </option>
    </select>
    <div class="invalid-feedback">{{ errorMessage }}</div>
  </form-layout>
</template>
<script>
import FormLayout from "@/views/templates/FormLayout";
import BaseVuexSearchItem from '@/views/molecules/searchItems/BaseVuexSearchItem'

export default {
  name: "VuexSelectSearchItem",
  extends: BaseVuexSearchItem,
  components: {
    FormLayout
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true,
      default: () => {
        return [
          {value: '1', text: ''},
          {value: '2', text: ''},
          {value: '3', text: ''},
        ]
      }
    },
    valueKey: {
      type: String,
      default: 'value',
    },
    textKey: {
      type: String,
      default: 'text',
    },
  },
}
</script>
